import React from "react";
import { formatDateEN, formatDateMoment, getCurrentDate } from "../../../common/utils/date";
import { getMyPerson } from "../../../common/utils/family";

class MySchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fces: this.props.fces };
  }

  getScheduleItem_v(fce) {
    let d = formatDateMoment(fce.Start);
    let start = formatDateEN(fce.Start);

    //fce.Name = fce.Name.replace("<br>", "");
    let p = getMyPerson(fce.PId, this.props.family);
    let name = p.FName + " " + p.LName;
    let det="";
    if(fce.SubsId != "00000000-0000-0000-0000-000000000000" && fce.Name.length>4) det=fce.Name.substring(4,fce.Name.length);

    return (
      <div className="row purchases-item">
        <div className="col-12">
          <div className="row">
            <div className="col-3 purchased-class-container pl-4">
              <p className="cart-item-info">
                <span id="class-type">{name} </span>
              </p>
            </div>
            <div className="col-3 purchased-class-container schelisttime">
              <p className="cart-item-info">
                <span id="class-type">{d}<br></br>{start} </span>
              </p>
            </div>
            <div className="col-6 purchased-className-container">
              <p className="sclisttit">{fce.Desc.replace(/<[^>]+>/g, "")} </p>
              {fce.SubsId != "00000000-0000-0000-0000-000000000000" && (
              <p className="cart-item-info actgschname">
                <span id="class-type">
                  <span dangerouslySetInnerHTML={{ __html: det }} />{" "}
                </span>
              </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getScheduleList_v() {
    const items = [];
    //let now = getCurrentDate();
    //let nowdate = new Date(now);
    //console.log(JSON.stringify(this.state.fces, null, 2));
    for (let i = 0; i < this.state.fces.length; i++) {
      //let fce = this.state.fces[i];
      //let fcedate = new Date(fce.Start);
      //if (fcedate > nowdate) {
        items.push(this.getScheduleItem_v(this.state.fces[i]));
      //}
    }

    return (
      <>
        <div className="d-flex justify-content-between align-items-center schedule-header rounded">
          <span className="schedule-title-date d-flex justify-content-center">
            Name
          </span>
          <span className="schedule-title-time d-flex justify-content-center">
            Time
          </span>
          <span className="schedule-title-detail d-flex justify-content-center pl-4">
            Detail
          </span>
        </div>
        <div className="pl-2 pr-2">{items}</div>
      </>
    );
  }

  render() {
    return <div>{this.getScheduleList_v()}</div>;
  }
}

export default MySchedule;